module.exports = __webpack_public_path__ + "img/background-ball.b58084ab.png";